import { render, staticRenderFns } from "./EmptyClientDialog.vue?vue&type=template&id=1219738e"
import script from "./EmptyClientDialog.vue?vue&type=script&lang=js"
export * from "./EmptyClientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports